"use client";
import useIsClient from "@/hooks/useIsClientSide";
import { getMobileUrl } from "@/utils/urls";
import { useRouter } from "next/navigation";
import { isMobile } from "react-device-detect";
import styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";

function JobNotFound() {
  const { t } = useTranslation();
  const isClient = useIsClient();
  const router = useRouter();

  if (!isClient) {
    return <div className="h-[500px] bg-gray-100 animate-pulse shadow-md" />;
  }
  return (
    <div
      className={`${styles.maxWidth} flex-shrink flex-grow md:flex flex-nowrap gap-x-2.5 pt-[10px]`}
    >
      <div className="mx-4 mt-5 text-center">
        <div className="bg-white px-5 py-5 shadow-sm rounded-md min-h-[500px] flex flex-col justify-around items-center">
          <div>
            <h1 className="font-semiBold text-mobile-h2 my-3">
              {t("Sehr geehrter Experteer-Nutzer,")}
            </h1>
            <h2 className="font-semiBold text-mobile-h3 my-3">
              {t(
                "leider ist die von Ihnen gesuchte Stelle nicht mehr verfügbar."
              )}
            </h2>
            <p className="my-3">
              {t(
                "Melden Sie sich auf Experteer an und finden Sie weltweit über"
              )}{" "}
              1.000.000{" "}
              {t(
                "alternative Spitzenpositionen für Professionals und Executives."
              )}
            </p>
          </div>
          <button
            className="px-4 py-3 max-w-[400px] bg-real-green text-white rounded-md font-bold"
            onClick={() => {
              const mobileDomain = getMobileUrl(window.location.host);
              const newUrl = `${mobileDomain}/career/app/search/start`;
              router.push(isMobile ? newUrl : "/jobs");
            }}
          >
            {t("Jetzt weitere Spitzenpositionen finden")}
          </button>
        </div>
      </div>
    </div >
  );
}

export default JobNotFound;
